'use es6';
'use client';

import * as React from 'react';
export const DirectionContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") DirectionContext.displayName = "DirectionContext";
export function useDirection() {
  var _context$direction;
  const context = React.useContext(DirectionContext);
  return (_context$direction = context === null || context === void 0 ? void 0 : context.direction) !== null && _context$direction !== void 0 ? _context$direction : 'ltr';
}